/* eslint-disable react-hooks/exhaustive-deps */
import Flex from '@Components/Bases/Flex';
import { FormInput } from '@Components/Form';
import { disabledFormInputStyles } from '@Components/Form/styles';
import FormatNumberInput from '@Components/FormattedNumberInput';
import { Box, InputLabel, styled, Typography } from '@mui/material';
import { useGreenhouseForm } from '../../EsgGreenhouseFormProvider';
import { useMemo } from 'react';
import { IGhGasScopeFormValues } from '../../EsgGreenhouseFormProvider/types';

const FormNumberInput = styled(FormInput)({
  '& input': {
    textAlign: 'right',
  },
});

enum SCOPE_FIELDS {
  SCOPE1 = 'performanceGhGasMgmtReport.ghGasEmissionVolume.ghGasScope1',
  SCOPE2 = 'performanceGhGasMgmtReport.ghGasEmissionVolume.ghGasScope2',
  SCOPE3 = 'performanceGhGasMgmtReport.ghGasEmissionVolume.ghGasScope3',
}

const totalEmissionCarbon = (scope1 = 0, scope2 = 0, scope3 = 0): number => {
  return Number(scope1) + Number(scope2) + Number(scope3);
};

const GreenhouseGasEmissionOrganizationTotalForm = () => {
  const { watch, setValue } = useGreenhouseForm();

  const [scope1, scope2, scope3] = watch([
    SCOPE_FIELDS.SCOPE1,
    SCOPE_FIELDS.SCOPE2,
    SCOPE_FIELDS.SCOPE3,
  ]) as [IGhGasScopeFormValues, IGhGasScopeFormValues, IGhGasScopeFormValues];

  const totalAsOfYear = useMemo(() => {
    const scope1Value = scope1?.asOfYear;
    const scope2Value = scope2?.asOfYear;
    const scope3Value = scope3?.asOfYear;

    if (!scope1Value && !scope2Value && !scope3Value) return 0;
    const total = totalEmissionCarbon(scope1Value, scope2Value, scope3Value);
    setValue(
      `performanceGhGasMgmtReport.ghGasEmissionVolume.totalGhGasConsumption.asOfYear`,
      total
    );
    return total;
  }, [scope1?.asOfYear, scope2?.asOfYear, scope3?.asOfYear]);

  const totalAsOfYesteryear = useMemo(() => {
    const scope1Value = scope1?.asOfYesteryear;
    const scope2Value = scope2?.asOfYesteryear;
    const scope3Value = scope3?.asOfYesteryear;

    if (!scope1Value && !scope2Value && !scope3Value) return 0;
    const total = totalEmissionCarbon(scope1Value, scope2Value, scope3Value);
    setValue(
      `performanceGhGasMgmtReport.ghGasEmissionVolume.totalGhGasConsumption.asOfYesteryear`,
      total
    );
    return total;
  }, [scope1?.asOfYesteryear, scope2?.asOfYesteryear, scope3?.asOfYesteryear]);

  const totalAsOfYearBeforeYesteryear = useMemo(() => {
    const scope1Value = scope1?.asOfYearBeforeYesteryear;
    const scope2Value = scope2?.asOfYearBeforeYesteryear;
    const scope3Value = scope3?.asOfYearBeforeYesteryear;

    if (!scope1Value && !scope2Value && !scope3Value) return 0;
    const total = totalEmissionCarbon(scope1Value, scope2Value, scope3Value);
    setValue(
      `performanceGhGasMgmtReport.ghGasEmissionVolume.totalGhGasConsumption.asOfYearBeforeYesteryear`,
      total
    );
    return total;
  }, [
    scope1?.asOfYearBeforeYesteryear,
    scope2?.asOfYearBeforeYesteryear,
    scope3?.asOfYearBeforeYesteryear,
  ]);

  return (
    <Flex width={1} alignItems={'center'}>
      <Box width={1} minWidth={235} maxWidth={350}>
        <InputLabel sx={{ textAlign: 'right', fontWeight: 800 }}>
          {`ปริมาณการปล่อยก๊าซเรือนกระจกรวม`}
        </InputLabel>
        <Typography textAlign={'right'} color={'text.secondary'}>
          {`(ตันคาร์บอนไดออกไซด์เทียบเท่า)`}
        </Typography>
      </Box>
      <Box
        width={1}
        display={'grid'}
        gridTemplateColumns={'repeat(3, 1fr)'}
        gap={3}
        ml={1}
      >
        <FormNumberInput
          name={`performanceGhGasMgmtReport.ghGasEmissionVolume.totalGhGasConsumption.asOfYearBeforeYesteryear`}
          placeholder={'กรุณาระบุจำนวน'}
          value={totalAsOfYearBeforeYesteryear}
          slotProps={{
            input: {
              inputComponent: FormatNumberInput as React.ComponentType,
            },
          }}
          sx={disabledFormInputStyles}
          fullWidth
        />
        <FormNumberInput
          name={`performanceGhGasMgmtReport.ghGasEmissionVolume.totalGhGasConsumption.asOfYesteryear`}
          placeholder={'กรุณาระบุจำนวน'}
          value={totalAsOfYesteryear}
          slotProps={{
            input: {
              inputComponent: FormatNumberInput as React.ComponentType,
            },
          }}
          sx={disabledFormInputStyles}
          fullWidth
        />
        <FormNumberInput
          name={`performanceGhGasMgmtReport.ghGasEmissionVolume.totalGhGasConsumption.asOfYear`}
          placeholder={'กรุณาระบุจำนวน'}
          value={totalAsOfYear}
          slotProps={{
            input: {
              inputComponent: FormatNumberInput as React.ComponentType,
            },
          }}
          sx={disabledFormInputStyles}
          fullWidth
        />
      </Box>
    </Flex>
  );
};

export default GreenhouseGasEmissionOrganizationTotalForm;
